module.exports = __webpack_public_path__ + "media/man bpen yàang née dtông mee ù-bpà-gon.4009eea1.mp3";